import { IconCheckDefault, IconTimesDefault } from '@iwoca/icons';
import { Card, Link, Spinner } from '@iwoca/orion';
import clsx from 'clsx';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { TIntroducerPermission } from 'types';
import styles from './AccountOverview.module.css';

const SUPPORT_EMAIL = 'brokers@iwoca.co.uk';

const ACCOUNT_PERMISSIONS: { key: TIntroducerPermission; label: string }[] = [
  { key: 'can_create_applications', label: 'Create apps' },
  { key: 'can_upload_broker_documents', label: 'Upload docs' },
  { key: 'can_interact_with_offers', label: 'Interact with offers' },
  { key: 'can_refresh_offers', label: 'Refresh offers' },
];

export const AccountOverview = () => {
  const {
    introducer,
    introducerCompany,
    isIntroducerLoading,
    checkIntroducerPermission,
  } = useIntroducerData();

  if (isIntroducerLoading) {
    return (
      <div className={styles.pageContent}>
        <Spinner />
      </div>
    );
  }

  const brokerage =
    introducerCompany?.public_facing_company_name ||
    introducerCompany?.company_name;
  const fullName = introducer
    ? `${introducer.first_name} ${introducer.last_name}`
    : '';

  return (
    <div className={styles.pageContent}>
      <h2 className={styles.heading}>Account overview</h2>

      {introducer && introducerCompany && (
        <Card className={styles.detailsCard}>
          <div className={styles.row}>
            <span className={styles.label}>Brokerage</span>
            <span className={styles.value}>{brokerage}</span>
          </div>

          <hr className={styles.divider} />

          <div className={styles.row}>
            <span className={styles.label}>Name</span>
            <span className={styles.value}>{fullName}</span>
          </div>

          <div className={styles.row}>
            <span className={styles.label}>Email</span>
            <span className={styles.value}>{introducer.email}</span>
          </div>

          <div className={styles.permissionsBlock}>
            <span className={styles.label}>Account permissions</span>
            <ul className={styles.permissionsGrid}>
              {ACCOUNT_PERMISSIONS.map(({ key, label }) => {
                const granted = checkIntroducerPermission(key);
                const Icon = granted ? IconCheckDefault : IconTimesDefault;
                return (
                  <li
                    key={key}
                    className={clsx(
                      styles.permission,
                      granted ? styles.granted : styles.denied,
                    )}
                  >
                    <Icon
                      className={styles.permissionIcon}
                      data-testid={
                        granted ? 'permission-tick' : 'permission-cross'
                      }
                    />
                    <span>{label}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </Card>
      )}

      <p className={styles.footer}>
        Need to update your permissions?{' '}
        <Link href={`mailto:${SUPPORT_EMAIL}`}>Contact us</Link> for assistance.
      </p>
    </div>
  );
};
